import NotificationLogo from '../../assets/img/bell.png';
import Logo from '../../assets/img/Settings.png';
import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  NavItem,
} from "reactstrap";
import routes from "../../routes/super";
import { BASE_URL } from "../../constants";

function Header(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [settingsDropdownOpen, setSettingsDropdownOpen] = React.useState(false);
  const [color, setColor] = React.useState("transparent");
  const [notifications, setNotifications] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const perPage = 5;
  const pageNo = 1;

  const navigate = useNavigate();
  const sidebarToggle = React.useRef();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData"));

  const toggle = () => {
    if (isOpen) {
      setColor("transparent");
    } else {
      setColor("dark");
    }
    setIsOpen(!isOpen);
  };

  const dropdownToggle = (e) => {
    setDropdownOpen(!dropdownOpen);
  };

  const settingsDropdownToggle = () => {
    setSettingsDropdownOpen(!settingsDropdownOpen);
  };

  const getBrand = () => {
    let brandName = "Default Brand";
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  };

  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };

  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("dark");
    } else {
      setColor("transparent");
    }
  };

  React.useEffect(() => {
    window.addEventListener("resize", updateColor.bind(this));
  });

  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
  };

  const fetchNotifications = () => {
    const token = localStorage.getItem("token");
    if (token) {
      fetch(
        `${BASE_URL}/notification/list?per_page=${perPage}&page_no=${pageNo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            const formattedNotifications = data.result.data.map(
              (notification) => ({
                title: notification.title,
                created_at: new Date(notification.created_at).toLocaleDateString('en-US'),
              })
            );
            setNotifications(formattedNotifications);
          } else {
            console.error("Error: Unable to fetch notifications.");
          }
        })
        .catch((error) => console.error("Error fetching notifications:", error))
        .finally(() => setLoading(false));
    } else {
      console.error("Error: Authorization token is missing.");
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <Navbar
      color={
        location.pathname.indexOf("full-screen-maps") !== -1 ? "dark" : color
      }
      expand="lg"
      className={
        location.pathname.indexOf("full-screen-maps") !== -1
          ? "navbar-absolute fixed-top"
          : "navbar-absolute fixed-top " +
          (color === "transparent" ? "navbar-transparent " : "")
      }
    >
      <Container fluid>
        <div className="navbar-wrapper">
          <div className="navbar-toggle">
            <button
              type="button"
              ref={sidebarToggle}
              className="navbar-toggler"
              onClick={() => openSidebar()}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
        </div>
        <NavbarToggler onClick={toggle}>
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar className="justify-content-end">
          <Nav navbar>

          {userData?.type !== "ADMIN" && (

            <Dropdown
              nav
              isOpen={dropdownOpen}
              toggle={(e) => dropdownToggle(e)}
            >
              <DropdownToggle caret nav>
                <img
                  src={NotificationLogo}
                  alt="Notifications"
                  style={{ width: "24px", marginRight: "5px" }}
                />
                <p>
                  <span className="d-lg-none d-md-block">Notifications</span>
                </p>
              </DropdownToggle>

              <DropdownMenu right style={{ minWidth: "300px" }}>
                {loading ? (
                  <DropdownItem disabled>Loading...</DropdownItem>
                ) : notifications.length === 0 ? (
                  <DropdownItem disabled>No notifications</DropdownItem>
                ) : (
                  notifications.map((notification, index) => (
                    <DropdownItem
                      key={index}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "none",
                        display: "block",
                      }}
                      onClick={() => {
                        navigate("/notifications");
                      }}
                    >
                      {notification.title}
                      <small style={{ display: "block", color: "gray" }}>
                        {notification.created_at}
                      </small>
                    </DropdownItem>
                  ))
                )}
                <DropdownItem divider />
                <DropdownItem tag={Link} to="/notifications">
                  See all notifications
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )
        }
            <Dropdown
              nav
              isOpen={settingsDropdownOpen}
              toggle={settingsDropdownToggle}
              className="d-none d-lg-block d-md-block"
            >
              <DropdownToggle caret nav>
                <img
                  src={Logo}
                  alt="Settings"
                  style={{ width: "24px", marginRight: "5px" }}
                />
                <span className="d-lg-none d-md-block">Settings</span>
              </DropdownToggle>
              <DropdownMenu right>
                {userData?.type === "OWNER" && !userData?.subscriptionPackage && (
                  <DropdownItem tag={Link} to="/packages">
                    Subscribe
                  </DropdownItem>
                )}
                <DropdownItem tag={Link} to="/account">
                  Edit Profile
                </DropdownItem>
                <DropdownItem
                  tag={Link}
                  to="/login"
                  onClick={handleLogout}
                >
                  Logout
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>

            {userData?.type === "OWNER" && !userData?.subscriptionPackage && (
              <NavItem className="d-lg-none d-md-none">
                <Link to="/packages" className="nav-link btn-rotate">
                  <i className="nc-icon nc-credit-card" style={{ marginRight: "8px" }} />
                  <span>Subscribe</span>
                </Link>
              </NavItem>
            )}


            <NavItem className="d-lg-none d-md-none">
              <Link to="/account" className="nav-link btn-rotate">
                <i className="nc-icon nc-single-02" style={{ marginRight: "8px" }} />
                <span>Edit Profile</span>
              </Link>
            </NavItem>
            <NavItem className="d-lg-none d-md-none">
              <Link to="/login" className="nav-link btn-magnify">
                <i className="nc-icon nc-button-power" style={{ marginRight: "8px" }} />
                <span onClick={handleLogout}>Logout</span>
              </Link>
            </NavItem>

          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
